// POST /auth/tenant-lookup — único endpoint público de la API.
// docs/Paquete_Arranque_Frontend.md §3 · backend/services/core/api/openapi.yaml
//
// Siempre responde 200, incluso si el correo no existe (found: false).
// No mostrar en la UI si una cuenta existe o no.

interface TenantLookupResponse {
  found: boolean;
  identityPlatformTenantId: string | null;
}

export async function tenantLookup(email: string): Promise<TenantLookupResponse> {
  const res = await fetch(`${import.meta.env.VITE_API_BASE_URL}/auth/tenant-lookup`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ email }),
  });

  if (!res.ok) {
    throw new Error(`tenant-lookup respondió ${res.status}`);
  }

  return res.json() as Promise<TenantLookupResponse>;
}
